export enum ContratoTipoNotificacao {
  ANALISE_OPERACIONAL_CONCLUIDA = 0,
  ALTERACAO_DE_SITUACAO = 1,
}

export enum ContratoStatus {
  EM_EDICAO = 0,
  EM_ANALISE = 1,
  AGUARDANDO_ASSINATURA = 2,
  NAO_INICIADO = 3,
  VIGENTE = 4,
  ENCERRADO = 5,
  DESATIVADO = 6,
  ASSINADO = 7,
  AGUARDANDO_EXTRATO = 8,
  ANALISE_OPERACIONAL_APROVADO = 9,
  ANALISE_OPERACIONAL_NEGADO = 10,
}

export const ContratoStatusDescricao = {
  EM_EDICAO: 'EM_EDICAO',
  EM_ANALISE: 'EM_ANALISE',
  AGUARDANDO_ASSINATURA: 'AGUARDANDO_ASSINATURA',
  NAO_INICIADO: 'NAO_INICIADO',
  VIGENTE: 'VIGENTE',
  ENCERRADO: 'ENCERRADO',
  DESATIVADO: 'DESATIVADO',
  ASSINADO: 'ASSINADO',
  AGUARDANDO_EXTRATO: 'AGUARDANDO_EXTRATO',
  ANALISE_OPERACIONAL_APROVADO: 'ANALISE_OPERACIONAL_APROVADO',
  ANALISE_OPERACIONAL_NEGADO: 'ANALISE_OPERACIONAL_NEGADO',
};

export enum TipoContrato {
  ASSESSOR = 1,
  ENTE_PUBLICO = 2,
  ENTE_PRIVADO = 3,
}
export enum TipoContratoDescricao {
  Todos = 'Todos',
  ASSESSOR = 'Assessor',
  ENTE_PUBLICO = 'Ente público',
  ENTE_PRIVADO = 'Ente privado',
}

export enum TipoFluxo {
  CENTRALIZADO = 1,
  DESCENTRALIZADO = 2,
}
export enum TipoFluxoDescricao {
  CENTRALIZADO = 'Centralizado',
  DESCENTRALIZADO = 'Descentralizado',
}

export enum TipoFluxoUrlDescricao {
  CENTRALIZADO = 'centralizado',
  DESCENTRALIZADO = 'descentralizado',
}

export enum VersaoContratoEnum {
  CONTRATO = 1,
  ADITIVO = 2,
  DISTRATO = 3,
}

export enum VersaoContratoDescricao {
  CONTRATO = 'contrato',
  ADITIVO = 'aditivo',
  DISTRATO = 'distrato',
}

export enum Steps {
  DADOS_COOPERATIVA = 0,
  DADOS_CONTRATADO = 1,
  DOCUMENTOS = 2,
}

export enum StepsDescricao {
  DADOS_COOPERATIVA = 'DADOS_COOPERATIVA',
  DADOS_CONTRATADO = 'DADOS_CONTRATADO',
  DOCUMENTOS = 'DOCUMENTOS',
}

export enum tipoContratoRoutes {
  TODOS = 'todos',
  ASSESSOR = 'assessor',
  ENTE_PUBLICO = 'ente-publico',
  ENTE_PRIVADO = 'ente-privado',
}

export const STEP_DADOS_COOPERATIVA = 0;
export const STEP_DADOS_CONTRATADO = 1;
export const STEP_DOCUMENTOS = 2;

export const allContratosTipo = () => [
  {
    value: TipoContrato.ASSESSOR,
    description: TipoContratoDescricao.ASSESSOR,
  },
  {
    value: TipoContrato.ENTE_PUBLICO,
    description: TipoContratoDescricao.ENTE_PUBLICO,
  },
  {
    value: TipoContrato.ENTE_PRIVADO,
    description: TipoContratoDescricao.ENTE_PRIVADO,
  },
];

export const allContratosFluxo = () => [
  {
    value: TipoFluxo.CENTRALIZADO,
    description: TipoFluxoDescricao.CENTRALIZADO,
  },
  {
    value: TipoFluxo.DESCENTRALIZADO,
    description: TipoFluxoDescricao.DESCENTRALIZADO,
  },
];

export const StatusDetails = {
  [ContratoStatus.EM_EDICAO]: {
    label: 'Em Edição',
    color: '#FFEB8C',
  },
  [ContratoStatus.EM_ANALISE]: {
    label: 'Em análise',
    color: '#B4EBFF',
  },
  [ContratoStatus.AGUARDANDO_ASSINATURA]: {
    label: 'Aguardando assinatura',
    color: '#B4EBFF',
  },
  [ContratoStatus.NAO_INICIADO]: {
    label: 'Não iniciado',
    color: '#B4EBFF ',
  },
  [ContratoStatus.VIGENTE]: {
    label: 'Vigente',
    color: '#A0DC8C',
  },
  [ContratoStatus.ENCERRADO]: {
    label: 'Encerrado',
    color: '#F58C96',
  },
  [ContratoStatus.DESATIVADO]: {
    label: 'Desativado',
    color: '#E1E6E1',
  },
  [ContratoStatus.ASSINADO]: {
    label: 'Assinado',
    color: '#FFEB8C',
  },
  [ContratoStatus.AGUARDANDO_EXTRATO]: {
    label: 'Aguardando extrato',
    color: '#B4EBFF',
  },
  [ContratoStatus.ANALISE_OPERACIONAL_APROVADO]: {
    label: 'Análise operacional aprovado',
    color: '#A0DC8C',
  },
  [ContratoStatus.ANALISE_OPERACIONAL_NEGADO]: {
    label: 'Análise operacional negado',
    color: '#F58C96',
  },
};

export const statusMapping: { [key: number]: ContratoStatus } = {
  0: ContratoStatus.EM_EDICAO,
  1: ContratoStatus.EM_ANALISE,
  2: ContratoStatus.AGUARDANDO_ASSINATURA,
  3: ContratoStatus.NAO_INICIADO,
  4: ContratoStatus.VIGENTE,
  5: ContratoStatus.ENCERRADO,
  6: ContratoStatus.DESATIVADO,
  7: ContratoStatus.ASSINADO,
  8: ContratoStatus.AGUARDANDO_EXTRATO,
  9: ContratoStatus.ANALISE_OPERACIONAL_APROVADO,
  10: ContratoStatus.ANALISE_OPERACIONAL_NEGADO,
};

export const VersaoContratoDetails = {
  [VersaoContratoEnum.CONTRATO]: {
    label: 'Contrato',
    color: '',
  },
  [VersaoContratoEnum.ADITIVO]: {
    label: 'Aditivo',
    color: '',
  },
  [VersaoContratoEnum.DISTRATO]: {
    label: 'Distrato',
    color: '',
  },
};

export const tipoContratoMapping: { [key: number]: VersaoContratoEnum } = {
  1: VersaoContratoEnum.CONTRATO,
  2: VersaoContratoEnum.ADITIVO,
  3: VersaoContratoEnum.DISTRATO,
};

export const URL_ENTE_DESCENTRALIZADO = {
  ENTE_PUBLICO: 'ente-publico-descentralizado',
  ENTE_PRIVADO: 'ente-privado-descentralizado',
  ASSESSOR: 'assessor-descentralizado',
};

export const URL_ADITIVO_PARAM = {
  CADASTRO_ADITIVO: 'cadastro-aditivo',
  EDICAO_ADITIVO: 'edicao-aditivo',
  MODAL_EDICAO_ADITIVO: 'edicao-aditivo=true',
  MODAL_CRIACAO_ADITIVO: 'criacao-aditivo=true',
  VERSAO: '2',
};

export const URL_DISTRATO_PARAM = {
  CADASTRO_DISTRATO: 'cadastro-distrato',
  EDICAO_DISTRATO: 'edicao-distrato',
  MODAL_EDICAO_DISTRATO: 'edicao-distrato=true',
  MODAL_CRIACAO_DISTRATO: 'criacao-distrato=true',
  VERSAO: '3',
};

export const CONTRATO_FLUXO_DESCENTRALIZADO = {
  ASSESSOR: 'assessor-descentralizado',
  ENTE_PUBLICO: 'ente-publico-descentralizado',
  ENTE_PRIVADO: 'ente-privado-descentralizado',
};

export const CONTRATO_ETAPAS_PARAMS_URL = {
  CADASTRO: 'cadastro-de-contratos',
  EDICAO: 'edicao-de-contratos',
};

export const CONTRATO_PASSOS = {
  DADOS_COOPERATIVA: 'dados-da-cooperativa',
  DADOS_CONTRATADO: 'dados-do-contratado',
  DOCUMENTOS: 'documentos',
};

export const CONTRATO_MODAL_DE_ARQUIVOS = {
  CONTRATO_ASSINADO: 1,
  PLANO_DE_TRABALHO: 2,
  CONTRATO_ASSINADO_E_PLANO_DE_TRABALHO: 3,
  EXTRATO: 4,
};
